import type { OpenDecision } from './types';

export const DECISIONS: OpenDecision[] = [
  { id: 'bounds', title: 'Saisie des corrections', destination: 'data',
    question: 'Quelles bornes appliquer ? La valeur zéro est-elle admissible ?',
    impact: 'Une correction positive est démontrable. Zéro reste à arbitrer ; aucun plafond métier supposé.',
    variants: ['Zéro autorisé', 'Valeur strictement positive'] },
  { id: 'conflict', title: 'Bâtiment supprimé mais utilisé', destination: 'sync',
    question: 'Comment résoudre le conflit ? Peut-on recalculer avant sa résolution ?',
    impact: 'La copie et les abonnements sont conservés. Aucune résolution destructive automatique.',
    variants: ['Conserver comme donnée locale', 'Retirer explicitement des plans après revue'] },
  { id: 'unused', title: 'Suppression sans abonnement', destination: 'sync',
    question: 'Que devient un bâtiment supprimé d’UrbanMap qui n’est utilisé dans aucun plan ?',
    impact: 'Cette suppression reste en attente. La synchronisation ne l’applique pas implicitement.',
    variants: ['Conserver dans le projet', 'Supprimer après confirmation'] },
  { id: 'targeting', title: 'Plans concernés par les changements', destination: 'plan',
    question: 'Comment cibler par énergie et traiter les plans en brouillon ?',
    impact: 'Les résultats existants sont conservés. Le ciblage énergie/brouillon doit être confirmé.',
    variants: ['Énergie concernée seulement', 'Tous les plans utilisant le bâtiment'] },
  { id: 'comparison', title: 'Indicateurs de comparaison', destination: 'compare',
    question: 'Quels indicateurs, linéaire et limite de sélection ? Quelles conditions de comparabilité ?',
    impact: 'Indicateurs illustratifs et contextes visibles, aucun classement ni limite métier imposée.',
    variants: ['Synthèse technique', 'Synthèse et détail du phasage'] },
  { id: 'layers', title: 'Couches UrbanMap en direct', destination: 'data',
    question: 'Faut-il inclure des couches en direct distinctes de la copie ?',
    impact: 'Aucun appel réel. Le prototype ne présente que ses données locales.',
    variants: ['Copie locale uniquement', 'Copie et références en lecture seule'] },
  { id: 'permissions', title: 'Permissions', destination: 'settings',
    question: 'Qui peut consulter, corriger, synchroniser et calculer ?',
    impact: 'Mode démonstration sans contrôle d’accès métier ; aucune matrice de droits inventée.',
    variants: ['Lecture seule exploratoire', 'Édition exploratoire'] },
  { id: 'drawing', title: 'Dessin manuel et contraintes', destination: 'plan',
    question: 'Les interdictions s’appliquent-elles aux dessins manuels ?',
    impact: 'Le dessin n’est pas validé topologiquement. Aucune conformité métier ne peut être annoncée.',
    variants: ['Interdictions sur tout tracé', 'Dessins traités comme exceptions explicites'] },
  { id: 'catalog', title: 'Catalogue de voirie', destination: 'scenario',
    question: 'Quels types de routes et ouvrages doivent être disponibles ?',
    impact: 'Voirie, pont et autoroute sont des exemples, pas un catalogue validé.',
    variants: ['Types de routes', 'Routes et ouvrages distincts'] },
  { id: 'parameters', title: 'Ratios, stations et formule DJU', destination: 'settings',
    question: 'Quelles valeurs métier et quelle formule de correction retenir ?',
    impact: 'Ratios et DJU sont des données de démonstration, sans valeur d’ingénierie.',
    variants: ['Station / DJU de référence', 'Formule à fournir par le métier'] },
];
